module.exports = __webpack_public_path__ + "static/AgeGateBottle-935614cd82d6f8c0e298290dfbf20600.png";